import React from "react";
import Link from "next/link";
import { GoArrowUpRight } from "react-icons/go";

const LinkContent = ({ title, content, color, link }) => {
  return (
    <Link
      href={link || ""}
      className={`rounded-[10px] ${!link && "pointer-events-none"} px-[24px] py-[48px] w-full h-full mt-4 flex flex-col justify-center relative`}
      style={{ backgroundColor: color }}
    >
      {link ? (
        <GoArrowUpRight
          color="white"
          className="absolute top-4 right-4"
          size={40}
        />
      ) : (
        <div className="absolute top-4 right-4 bg-[#202020] bg-opacity-60 text-white rounded-[24px] py-[5px] px-[12px]">շուտով</div>
      )}
      <span className="text-[32px] text-left font-[600] text-white">
        {title}
      </span>
      <div className="text-[18px] font-[600] text-left w-full mt-4 text-white">
        {content?.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>
    </Link>
  );
};

export default LinkContent;
